export const environment = {
  production: false,
  environmentName: 'qa',
};
